export default "__VITE_ASSET__Qu01wv07__"